module.exports = __webpack_public_path__ + "img/電気回路_3_1_3.89ed1b60.png";